import type { DateOutageRecord } from "src/types";

export const outagesMerger = (objValue: DateOutageRecord, srcValue: DateOutageRecord) => {
    if (Array.isArray(objValue)) {
        return objValue.concat(srcValue);
    }
    return undefined;
};
